"use strict";
/**
 * @module Services.MetricCollectors
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A list of topic metric collectors.
 */
var TopicMetricCollectorListImpl = /** @class */ (function () {
    /**
     * Create a new TopicMetricCollector instance
     *
     * @param collectors the collectors
     */
    function TopicMetricCollectorListImpl(collectors) {
        this.collectors = collectors;
    }
    return TopicMetricCollectorListImpl;
}());
exports.TopicMetricCollectorListImpl = TopicMetricCollectorListImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metric-collectors/topic-metric-collector-list.js
// module id = 1975
// module chunks = 1